import React, {Component} from "react";
import {Link} from "react-router-dom";
import flow1 from "../../../../../assets/img/flow1.png";
import flow2 from "../../../../../assets/img/flowBottom.png";
import flowBottomPlus from "../../../../../assets/img/sgh.png";
import homepage from "../../../../../assets/img/kitcut_homepage.png"
import pcbScreenShot from "../../../../../assets/img/kitcut_pcb_screenshot.png"
import pcbScreenShot1 from "../../../../../assets/img/kitcut_pcb_screenshot1.png"
import cart_flow from "../../../../../assets/img/checkout_flow.png"
import paypal_flow from "../../../../../assets/img/cart-flow.png"

import delivery from "../../../../../assets/img/flow_delivery_img.png"
import delivery1 from "../../../../../assets/img/flow_delivery_img1.png"
import pcbColor from "../../../../../assets/img/pcbColor.png"
import './Flow.css';
import correct from "../../../../../assets/img/correct.png";
import excla from "../../../../../assets/img/excla.jpeg";
import InitialQuotationState from "../../../QuotationForm/InitialQuotationState";

import flow from "../../../../../assets/img/flowProcess.png";
import {Modal} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import UserInquiryForm from "../../../UserInquiryForm/UserInquiryForm";
import {PAGE_OPEN_TYPE} from "../../../../../configuration";
import VisaAEMaster from "../../../../../assets/img/VisaAEMaster.png";
import StripeScreen from "../../../../../assets/img/stripeScreen.png";
import orderall from "../../../../../assets/img/orderall.png"
import MetaTags from "react-meta-tags";

class Flow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            quotation: {...InitialQuotationState.quotationType3},
            show: false
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleClose = () => {

        this.setState({show: false});
        InitialQuotationState.fromFlow = false;

    };

    handleShow = () => {
        this.setState({show: true});
        InitialQuotationState.fromFlow = true;

    };

    componentDidMount() {
        window.scrollTo(0, 0);

    }

    render() {

        return (

            <div className="static-pages">
                <MetaTags>
                    <title>サービス全体の流れ｜プリント基板のネット通販｜KITCUT PCB </title>
                    <meta property="title" content="サービス全体の流れ｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta name="title" content="サービス全体の流れ｜プリント基板のネット通販｜KITCUT PCB"/>
                    <meta property="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                    <meta name="description" content="プリント基板のネット通販 KITCUT PCBのプリント基板製造サービス、１枚から量産価格！今すぐ見積スタート、WEBで簡単に見積・注文が可能で生産状況をリアルタイムで表示。" lang="ja" />
                </MetaTags>
                <div className="background-div">
                    <div className="row">
                        <div className="align-elements">
                            <p className="static-pages-headings">
                                サービス全体の流れ
                            </p>
                        </div>
                        <div className="flow-img-first-div">

                            <img alt="Flow" src={flow} className="flow-img-first"/>
                        </div>

                        <div>
                            <div>

                                <p className="static-pages-headings">
                                    <span className="testHeader">1 </span>
                                    <span>ユーザー登録</span>
                                </p>

                            </div>
                            <div className="flow-div-font-16">
                                <p>
                                    キットカットラボのサービスをご利用いただくには
                                    <span className='bold-span'>「会員登録」</span>が必要です。
                                </p>
                                <p>
                                    パソコン・スマートフォンから無料で登録をすることができます。
                                </p>

                            </div>
                            <div className="static-page-btn-div">
                                <Link to="/register">
                                    {/*<button className="static-page-button">*/}
                                    {/*    会員登録はこちら*/}
                                    {/*</button>*/}
                                    <button className="begin-button yu-gothic-regular regstr btnsize">
                                        会員登録はこちら
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <p className="static-pages-headings">
                            <span>基板サンプルのご請求</span>
                        </p>
                        <div className="col-md-6 image-align-center-flow">
                            <img alt="PCB COLOR IMAGE" src={pcbColor} className="flow-img-second "/>
                        </div>
                        <div className="col-md-6 flow-div-font-16">
                            <p>&nbsp;実際のサンプルとは異なります。</p>

                            <p>「基板製造を頼みたいけど、仕上がりのイメージがつかめない･･･」</p>

                            <p>「実際に基板サンプルで確かめてみたい。」そんなお客様の声にお答えして</p>

                            <p>&nbsp;&nbsp;基板製造をもっとカンタンに、キットカットPCBをもっと身近に感じて</p>

                            <p>&nbsp;&nbsp;いただくための基板サンプルをご用意いたしました。</p>

                            <p>&nbsp;&nbsp;まずは、お気軽にご請求ください。</p>
                            {/*<br/>*/}
                            {/*<div className="static-page-btn-div">*/}
                            {/*    <button className="static-page-button-red"*/}
                            {/*            onClick={this.handleShow}>*/}
                            {/*        無料基板サンプル請求*/}
                            {/*    </button>*/}

                            {/*   */}
                            {/*</div>*/}
                            <div className="static-page-btn-div">
                                &nbsp;
                                <button className="begin-button yu-gothic-regular   btn-free-print btnsize "
                                        onClick={()=>{document.getElementById("sub-title-span-resp").click()}}>
                                    {/*無料印刷サンプルを請求する*/}
                                    無料基板サンプル請求
                                </button>
                            </div>
                        </div>

                    </div>
                    <br/>
                    <div className="row">
                        <div className="align-elements">
                            <p className="static-pages-headings">
                                基板サンプルが届くまでの流れ
                            </p>
                        </div>
                        {/*<div className="flow-img">*/}
                        {/*<img alt="DELIVERY" src={delivery} className="flow-img img-flow col-md-12"/>*/}
                        {/*</div>*/}

                        {/*///////////////////////////////////////////////////////////////////////////////////////////*/}
                        <div className="flow-img-first-div">
                            <img alt="DELIVERY" src={delivery1}
                                 className="img-flow col-md-12 unset-float-flow"/>
                        </div>
                        <div className="delivery-font-size">
                            <div className="custom-col-4 col-md-4 vertical-align-mobile ">
                                <span><b>①　請求フォームのご入力 </b><br/>
                                        ポストに直接投函いたしますので <br/>
                                        間違いや記入漏れにご注意ください。
                                </span>
                            </div>
                            <div className="custom-col-4 col-md-4 vertical-align-mobile ">
                                <span>
                                   <b> ②　受付完了メール </b><br/>
                                    受付完了した後に確認メールを送信します。
                                </span>
                            </div>
                            <div className="custom-col-4 col-md-4 vertical-align-mobile ">
                                <span>
                                   <b> ③　メール便にてお届け</b> <br/>
                                    ご登録いただいた送付先のポストに投函
                                    いたします。 <br/>
                                    ※お届けまでに1週間ほどお時間がかか
                                    ります。
                                </span>
                            </div>
                        </div>
                        {/*///////////////////////////////////////////////////////////////////////////////////////////*/}

                    </div>
                    <div className="row">
                        <p className="static-pages-headings">
                            <span className="testHeader">2 </span>
                            <span>オンライン見積り</span>
                        </p>

                        <div className="col-md-6">
                            <img alt="HOMEPAGE" src={homepage} className="flow-img"/>
                        </div>
                        <div className="col-md-6 flow-div-font-16">
                            <p className='padding-remove-flow'>トップページの左側の見積画面から基板サイズ、数量、層数、板厚を

                                <br/> 選択し“見積スタート”ボタンをクリックしてください。</p>
                        </div>

                    </div>
                    <div className="mobile-view-hide-flow-br">
                        <br/>
                        <br/>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <img alt="PCB SCREEN" src={pcbScreenShot} className="flow-img"/>
                        </div>
                        <div className="col-md-6 flow-div-font-16">
                            <p>それぞれの基板仕様・枚数に応じて料金・出荷予定日が</p>
                            <p>変わりますのでよくご確認ください。</p>
                            <br/>
                            <p><b>※基板製造費に、輸入申告諸費用（関税、消費税、国内外送料）</b></p>
                            <p><b>全て含まれています。</b></p>
                            <p><b>お客様にて荷物を受け取る際に別途お支払い頂く必要はございません。</b></p>
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <p className="static-pages-headings">
                            <span className="testHeader">3 </span>
                            <span>ガーバーファイルのアップロード <small>(RS-274X)</small></span>
                        </p>
                        {/*<br/>*/}
                        <div className="col-md-6">
                            <img alt="HOMEPAGE" src={pcbScreenShot1} className="flow-img"/>
                        </div>
                        <div className="col-md-6 flow-div-font-16">
                            <p> 算出された料金明細で問題無ければ、アップロード画面より</p>

                            <p> データをアップロードして“カートに保存”をクリックします。</p>
                            <br/>
                            <p>※ZipまたはRar圧縮ファイルにしてアップロードしてください。（最大 4MB)</p>
                            <br/>
                            <p className="color-red">［ご注意］</p>

                            <p> 拡張ガーバーデータ（RS-274X）以外のフォーマットでの</p>

                            <p>基板製造はお断りしております。</p>
                        </div>

                    </div>
                    <br/>
                    <div className="flow-div-font-16">
                        <p>
                            アップロードされたガーバーファイルは最新システムにより自動でデータチェックが行われます。

                        </p>
                        <p>
                            アップロード後、あなたの基板サイズ、層数を自動検出されます。

                        </p>
                        <p>
                            ※アップロード後、まれにガーバーファイルイメージが表示されない場合がありますが(現在のビュワー率 60%)

                        </p>
                        <p>
                            ビュワーされない場合でもガーバーファイルに問題がないかファイルチェック作業は行いますのでご安心ください。

                        </p>
                        {/*<p>*/}
                        {/*    ※ファイルに問題が検出されなかった内容に*/}
                        {/*    <span>*/}
                        {/*        <img src={correct} className="img-correct"/>*/}
                        {/*    </span>*/}
                        {/*    マークが表示されます。*/}

                        {/*</p>*/}
                        {/*<p>*/}
                        {/*    ※ファイルに問題が検出されました内容に*/}
                        {/*    <span>*/}
                        {/*        <img src={excla} className="img-excla"/>*/}
                        {/*    </span>*/}
                        {/*    マークが表示されます。*/}

                        {/*</p>*/}
                        {/*<p>*/}
                        {/*    ※*/}
                        {/*    <span>*/}
                        {/*        <img src={excla} className="img-excla"/>*/}
                        {/*    </span>*/}
                        {/*    マークが表示された場合、エラー内容に基づいて修正お願い致します。*/}

                        {/*</p>*/}
                    </div>
                    <br/>
                    <div className="row">
                        <p className="static-pages-headings">
                            <span className="testHeader">4 </span>
                            <span>お支払い</span>
                        </p>
                        {/*<br/>*/}
                        <div className="flow-div-font-16">
                            <p className="">
                                ショッピングカートにて注文する基板を
                                選択しお支払い手続きに進みます。
                            </p>

                        </div>

                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-6 text-center">
                            <img className="size-reduced" src={paypal_flow} alt=""/>
                        </div>
                        <div className="col-md-6 flow-div-font-16">
                            <p>
                                注文確認画面にて
                                お客様情報、お届け先住所に間違いがないか
                                ご確認のうえお支払いを選択してください。
                            </p>
                            <p>
                                キットカットPCBでは、商品のお届け先
                                請求先住所を複数登録することができます。
                                直接クライアント先へ納品する場合
                                などに便利です。
                                但し出荷元はキットカットPCB名義となります。
                            </p>
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-6 text-center">
                            <img className="size-reduced" src={cart_flow} alt=""/>
                        </div>
                        <div className="col-md-6 flow-div-font-16">
                            <p><b>クレジットカード支払い</b></p>

                            <p>ご利用可能なクレジットカードは下記の３つです。</p>
                            <p className="visa-ae-master-resp-img-p">
                                <img src={VisaAEMaster} alt="Visa/American Express/MasterCard"
                                     className="visa-ae-master-resp-img"/>
                            </p>
                            <p>
                                <img src={StripeScreen} alt="Stripe" className="stripe-resp-img"/>
                            </p>
                            <p>「カード情報の入力」画面が表示されます。</p>
                            <p>メールアドレス、カード番号、カード有効
                                期限セキュリティコード、所有者名を入力
                                し支払いボタンをクリックてください。 </p>
                            <p className="text-danger">
                                <b>【ご注意】クレジットカードを選択された場合</b>
                            </p>
                            <p>
                                お支払いは「一括払い」のみとなります。
                                分割払いには対応しておりません。
                                クレジットカードのご利用はご本人または
                                会社様名義のカードに限らせていただきます
                            </p>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 flow-div-font-16">
                            <p><b>PayPalアカウントでの支払い</b></p>
                            <p>
                                世界で 2 億 5000 万人以上が利用する
                                オンライン決済サービスです。
                                ペイパルは支払い情報を伝えない安心
                                ・安全な決済サービスです。
                            </p>
                            <p>
                                ビジネスでのお支払い・送金・決済受け
                                付けなどに利用する場合は、下記よりビ
                                ジネスアカウントの登録へお進み下さい
                            </p>
                            <p>
                                ※ビジネスでクレジットカードや銀行口座の決済に対応 “できる”。

                            </p>
                            <p>
                                <a href="https://www.paypal.com/jp/webapps/mpp/merchant" target={PAGE_OPEN_TYPE}>
                                    決済導入(ビジネス向け)へ
                                </a>
                            </p>
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <p className="static-pages-headings">
                            <span className="testHeader">5 </span>
                            <span>オペレーターによるガーバーファイル確認</span>
                        </p>
                        {/*<br/>*/}
                        <div className="flow-div-font-16">
                            {/* <p className="">
                                ガーバーファイル承認後、結果をメールにてご連絡いたします。
                            </p>*/}

                            <p className="">
                                提供されたガーバーファイルに製造上問題が発生する場合は承認されません。
                            </p>

                            <p className="">
                                ガーバーファイルに問題があり承認されない場合は、エラー内容を担当者よりメールにてご連絡いたします。
                            </p>
                            <p className="color-red">
                                承認されない場合は全額返金されます。
                            </p>
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <p className="static-pages-headings">
                            <span className="testHeader">6 </span>
                            <span>生産</span>
                        </p>
                        {/*<br/>*/}
                        <div className="flow-div-font-16">
                            <p className="">
                                あなたのマイアカウントに注文履歴が表示されますので
                                該当商品画面にて生産の進捗状況がご確認いただけます。
                            </p>
                            <p className="orderall-mobile">
                                <img src={orderall} alt=""/>
                            </p>

                        </div>

                    </div>
                    <br/>
                    <div className="row">
                        <p className="static-pages-headings">
                            <span className="testHeader">7 </span>
                            <span>香港集荷</span>
                        </p>
                        {/*<br/>*/}
                        <div className="flow-div-font-16">
                            <p className="">
                                統括拠点である香港のメリットを生かして検品・梱包・集荷・出荷致します。
                            </p>
                            <p className="">
                                香港出荷より3～4日前後で商品がお手元に届きます。
                            </p>
                            <p className="">
                                配送方法・配送業者につきましては、「⑧ <span className="color-blue">配送」</span>ページをご覧ください。
                            </p>
                            <p className="">
                                ※商品のご到着日時は確約いたしかねますので、予めご了承ください。
                            </p>
                            {/*<p className="">
                                ※商品のお届けは早くても出荷日の翌日以降となります。
                            </p>*/}
                        </div>

                    </div>
                    <br/>
                    <div className="row">
                        <p className="static-pages-headings">
                            <span className="testHeader">8 </span>
                            <span>配送</span>
                        </p>
                        {/*<br/>*/}

                        <div className="col-md-6">
                            <div className="row">
                                <a href="https://www.sgh-globalj.com/">
                                    <img src={flowBottomPlus} className="flow-img img-border"
                                         width="60"/></a>
                            </div>
                        </div>
                        <div className="col-md-6 no-padding shipping-div-flow-resp">
                            <div className="flow-div-font-16">
                                <p className="">
                                    当社は佐川急便の宅配輸送網を生かし日本向けドアツードアSgx（国際宅配便サービス）にて<br className="responsive-break-static"/> お届けします。
                                </p>
                                <p className="">
                                    お客様による宅配業者の指定はできません。
                                </p>
                                <p className="">
                                    商品が出荷されますと、マイアカウント、該当基板の輸送状況にて問い合わせ番号が表示されますので佐川の荷物お問い合わせの
                                </p>
                                <p className="">
                                    ページよりご確認、お問い合わせください。
                                </p>
                                <p className="">
                                    ※国際配送便のため、到着予定日中の到着に<br className="responsive-break-static"/>なります。
                                </p>
                                <p className="">
                                    ※お届け予定は運送会社様の事情、交通事情、気象状況等により予定日にお届けできない場合が<br className="responsive-break-static"/> ございます。
                                </p>
                            </div>
                        </div>




                    </div>
                </div>
                <Modal dialogClassName="modal-responsive" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.navigation.contact"
                                              defaultMessage="Contact"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="contact-form-text">
                            <UserInquiryForm userId={InitialQuotationState.loggedUserId}
                                             handle={this.handleClose}/>
                        </div>

                    </Modal.Body>
                </Modal>

            </div>

        );
    }


}

export default Flow;




// WEBPACK FOOTER //
// ./src/components/Site/SiteRoot/Navigation/LinkPages/Flow.js